import { extractIDs } from "helpers/extractIDs"
import { validateObject } from "helpers/validateObject"
import { useRevalidateFetch } from "hooks/useRevalidateFetch"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setDataToSend } from "redux/actions/invoices/invoicesCashAction"
import { getCRE_Licenses } from "redux/actions/purchases/purchasesAction"

export const useTransmitterHook = ({
  setValues, values, validate, reset, hasCashConceptRule
}) => {
  const dispatch = useDispatch()
  const { noteUnification, readyToSend, clearForm } = useSelector(({ cashInvoices }) => cashInvoices)
  const { companiesList } = useSelector(({ companies }) => companies)
  const { creLicenses } = useSelector(({ purchases }) => purchases)
  const {
    idCompany,
    rfc,
    permission,
    series,
    logo,
    invoiceConcept
  } = values
  useRevalidateFetch(getCRE_Licenses, creLicenses)

  const saveData = () => {
    const TransmitterData = {
      idCompany: idCompany.id,
      rfc: rfc?.trim(),
      creLicense: permission.label,
      idSerie: series?.id,
      logo: logo?.logo,
      ...(hasCashConceptRule && { invoiceConcept: invoiceConcept?.trim() || undefined })
    }
    dispatch(setDataToSend('transmitter', TransmitterData))
  }

  useEffect(() => {
    idCompany?.rfc && setValues({ rfc: idCompany.rfc })
  }, [idCompany])

  useEffect(() => {
    if (validateObject(noteUnification) && noteUnification.company?.id) {
      const companyF = companiesList.find(comp => comp.id === noteUnification.company.id)
      setValues({ company: companyF })
    }
  }, [noteUnification])

  useEffect(() => {
    if (creLicenses.length > 0 && idCompany) {
      const companyF = companiesList.find(comp => comp.id === idCompany.id)
      const stationsIDS = extractIDs(companyF?.stations)
      const permissionsF = creLicenses.filter(cre => stationsIDS.includes(cre.id))
      setValues({ permissionsOpt: permissionsF })
    }
  }, [idCompany, creLicenses, noteUnification])

  useEffect(() => {
    readyToSend && validate([], saveData)
  }, [readyToSend])

  useEffect(() => {
    if (clearForm) {
      reset()
    }
  }, [clearForm])
}